module.exports = __webpack_public_path__ + "static/img/GBCInteraction.3b89aa1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GBCInteraction.png
// module id = glSm
// module chunks = 29